<template>
    <div class="sm_ticketBox" v-bind:data-testid="`bet-builder-slip-leg-${subBetDisplay.selection.id}`">
        <div class="sm_ticket">
            <div class="betBuilderInfo">
                <div class="marketType">
                    <span
                        v-if="scoreDisplay"
                        class="live-score"
                        data-testid="bet-builder-slip-leg-score"
                    >{{ scoreDisplay }}</span>
                    {{ subBetDisplay.marketDisplayName }}
                </div>
                <div class="oddsGroup">
                    <span class="oddsType">{{ subBetDisplay.optionName }}</span>
                    <span v-if="subBetDisplay.point" class="oddsPoint">{{ subBetDisplay.point }}</span>
                </div>
            </div>
        </div>
        <div class="sm_value">
            <div
                class="sm_btn_close MiniBetBuilderSlip_Btn_DeleteTicket"
                v-on:click="removeTicketOrBetSlip(subBetDisplay.selection.id)"
            >
                <svg
                    id="systemIcon_close2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                >
                    <g
                        id="ico_close-2"
                        data-name="ico_close"
                        opacity="0.4"
                    >
                        <path
                            id="ico_close-3"
                            data-name="ico_close"
                            d="M15,8a7,7,0,1,0,7,7A7,7,0,0,0,15,8Zm3.432,8.837a.339.339,0,0,1,0,.48l-1.118,1.115a.339.339,0,0,1-.48,0L15,16.581l-1.838,1.852a.339.339,0,0,1-.48,0l-1.115-1.118a.339.339,0,0,1,0-.48L13.419,15l-1.852-1.838a.339.339,0,0,1,0-.48l1.118-1.118a.339.339,0,0,1,.48,0L15,13.419l1.837-1.852a.339.339,0,0,1,.48,0l1.118,1.118a.339.339,0,0,1,0,.48L16.581,15Z"
                            transform="translate(-8 -8)"
                            fill="#7c7c7c"
                        />
                    </g>
                </svg>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent } from 'vue';
    import type { IBetBuilderTicket } from '@/interface/betSlip';
    import { i18n } from '@/libraries/i18n';
    import { toFixedDecimalPoint } from '@/libraries/utils/text';
    import { useBetBuilderBetSlipStore } from '@/stores/betSlip/betBuilderBetSlipStore';

    export default defineComponent({
        name: 'MediumBetBuilderTicket',
        props: {
            subBet: {
                type: Object as PropType<IBetBuilderTicket>,
                required: true,
            },
            scoreDisplay: {
                type: String,
                default: '',
            },
        },
        setup(props) {
            const { removeTicketOrBetSlip, convertBetBuilderTicket } = useBetBuilderBetSlipStore();

            const subBetDisplay = computed(() => convertBetBuilderTicket(props.subBet));

            return {
                removeTicketOrBetSlip,
                i18n,
                toFixedDecimalPoint,
                subBetDisplay,
            };
        },
    });
</script>
